
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { urls } from '../../../utils/url-utils';
import { errorHandl } from '../../../utils/network-utils';
import { element } from 'protractor';
import * as moment from "moment-timezone";
import { getDistanceFromLatLon } from 'src/app/utils/utils.common';

@Injectable({
  providedIn: 'root'
})
export class AssigTripsService {


  constructor(private http: HttpClient) {
  }

  getAssignList(endPoint): Observable<any> {
    let params = new HttpParams();

    if (endPoint.isShowAllTrips)
      params = params.append('isShowAllTrips', endPoint.isShowAllTrips);

    params = params.append('status', endPoint.status);

    if (endPoint.skip)
      params = params.append('skip', endPoint.skip);

    if (endPoint.date) {
      params = params.append('scheduleTime', endPoint.date);
    }

    if (endPoint.jobStatuses) {
      params = params.append('jobStatuses', endPoint.jobStatuses);
    }

    if (endPoint.scheduleTime) {
      params = params.append('scheduleTime', endPoint.scheduleTime);
    }

    params = params.append('showBreak', endPoint.showBreak);

    return this.http.get<any>(urls.BASE_URL + `${urls.GET_UNASSIGN_TRIPS_URL}`, { params })
      .pipe(
        catchError(errorHandl)
      );
  }

  getTripList(endPoint): Observable<any> {
    let params = new HttpParams();

    if (endPoint.isShowAllTrips)
      params = params.append('isShowAllTrips', endPoint.isShowAllTrips);

    params = params.append('status', endPoint.status);

    if (endPoint.skip)
      params = params.append('skip', endPoint.skip);

    if (endPoint.date) {
      params = params.append('scheduleTime', endPoint.date);
    }

    if (endPoint.jobStatuses) {
      params = params.append('jobStatuses', endPoint.jobStatuses);
    }

    if (endPoint.isRawData) {
      params = params.append('isRawData', endPoint.isRawData);
    }


    return this.http.get<any>(urls.BASE_URL + `${urls.GET_UNASSIGN_TRIPS_URL}`, { params })
      .pipe(
        catchError(errorHandl)
      );
  }
  getAssignManifestList(endPoint): Observable<any> {
    let params = new HttpParams();
    params = params.append('isShowAllTrips', endPoint.isShowAllTrips);
    params = params.append('status', endPoint.status);
    params = params.append('isRecurring', endPoint.isRecurring);

    if (endPoint.skip)
      params = params.append('skip', endPoint.skip);

    if (endPoint.date) {
      params = params.append('scheduleTime', endPoint.date);
    }

    if (endPoint.jobStatuses) {
      params = params.append('jobStatuses', endPoint.jobStatuses);
    }

    if (endPoint.status === 'associatestandingorder') {
      params = params.append('so', endPoint.so);
    }


    return this.http.get<any>(urls.BASE_URL + `${urls.GET_UNASSIGN_TRIPS_URL}/getmanifesttrips`, { params })
      .pipe(
        catchError(errorHandl)
      );
  }
  getOutstandingTrips(payload): Observable<any> {
    // let params = new HttpParams();
    // params = params.append('driver', endPoint.driver);
    // params = params.append('scheduleTime', endPoint.scheduleTime);

    // return this.http.get<any>(urls.BASE_URL + urls.GET_OUTSTANDING_TRIPS_URL, { params })
    //   .pipe(
    //     catchError(errorHandl)
    //   );

    return this.http.post<any>(urls.BASE_URL + urls.GET_OUTSTANDING_TRIPS_URL, payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  getBulkWriteTrips(payload): Observable<any> {
    return this.http.put<any>(urls.BASE_URL + urls.GET_BULKWRITE_TRIPS_URL, payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  getStandingOrders(): Observable<any> {

    return this.http.put<any>(urls.BASE_URL + urls.GET_OUTSTANDING_TRIPS_URL, {})
      .pipe(
        catchError(errorHandl)
      );
  }

  getOutstandingTripsForBucket(payload): Observable<any> {
    let params = new HttpParams();
    params = params.append('scheduleTime', payload.scheduleTime);

    return this.http.get<any>(urls.BASE_URL + urls.GET_OUTSTANDING_TRIPS_URL, { params })
      .pipe(
        catchError(errorHandl)
      );
  }

  getBulkwriteTripsForBucket(payload): Observable<any> {
    let params = new HttpParams();
    params = params.append('scheduleTime', payload.scheduleTime);

    return this.http.get<any>(urls.BASE_URL + urls.GET_BULKWRITE_TRIPS_URL, { params })
      .pipe(
        catchError(errorHandl)
      );
  }

  getUnparsedTrips(endPoint): Observable<any> {
    let params = new HttpParams();
    params = params.append('rawId', endPoint.rawId);

    return this.http.get<any>(urls.BASE_URL + urls.GET_UNPARSED_TRIPS_URL, { params })
      .pipe(
        catchError(errorHandl)
      );
  }

  getSweepTripsList(): Observable<any> {
    return this.http.get<any>(urls.BASE_URL + urls.GET_SWEEP_TRIPS_LIST_URL)
      .pipe(
        catchError(errorHandl)
      );
  }

  removeSweepTrips(data): Observable<any> {

    return this.http.post<any>(urls.BASE_URL + urls.GET_SWEEP_TRIPS_LIST_URL + '?assignId=' + data._id, data)
      .pipe(
        catchError(errorHandl)
      );
  }

  sendTripListEmail(data): Observable<any> {

    return this.http.put<any>(urls.BASE_URL + urls.SEND_TRIP_LIST_EMAIL_URL + data._id, data)
      .pipe(
        catchError(errorHandl)
      );
  }


  calculateFare(id): Observable<any> {

    return this.http.get<any>(urls.BASE_URL + urls.GET_UNASSIGN_TRIPS_URL + `/tempbrokerfare/${id}`)
      .pipe(
        catchError(errorHandl)
      );
  }

  cloneTrip(id): Observable<any> {

    return this.http.get<any>(urls.BASE_URL + urls.GET_UNASSIGN_TRIPS_URL + `/clonetrip/${id}`)
      .pipe(
        catchError(errorHandl)
      );
  }
  removeTrip(data, id): Observable<any> {

    return this.http.post<any>(urls.BASE_URL + urls.GET_UNASSIGN_TRIPS_URL + `/${id}`, data)
      .pipe(
        catchError(errorHandl)
      );
  }

  noShowCancelTrip(data): Observable<any> {
    return this.http.post<any>(urls.BASE_URL + urls.GET_UNASSIGN_TRIPS_URL + '/marknoshow', data)
      .pipe(
        catchError(errorHandl)
      );
  }

  UpdateTripStatusWithNgrx(payload): Observable<any> {
    const id = payload._id;
    return this.http.put<any>(urls.BASE_URL + urls.GET_UNASSIGN_TRIPS_URL + `/${id}`, payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  sendToMarketplace(payload): Observable<any> {
    const id = payload._id;
    return this.http.put<any>(urls.BASE_URL + urls.GET_UNASSIGN_TRIPS_URL + `/${id}`, payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  updateAssociateImg(payload): Observable<any> {
    const id = payload._id;
    return this.http.put<any>(urls.BASE_URL + urls.GET_UNASSIGN_TRIPS_URL + `/${id}`, payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  updateCompTripImg(payload): Observable<any> {
    const id = payload._id;
    return this.http.post<any>(urls.BASE_URL + urls.GET_COMPLETED_TRIPS_URL, payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  markCompletedTrip(payload): Observable<any> {
    const id = payload._id;
    return this.http.post<any>(urls.BASE_URL + urls.MARK_COMPLETED_TRIP + `?assignId=${id}`, payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  addSpecialRate(payload): Observable<any> {
    const id = payload._id;
    return this.http.put<any>(urls.BASE_URL + urls.GET_UNASSIGN_TRIPS_URL + `/${id}`, payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  getAssignTripsList(requestData): Observable<any> {

    return this.http.post<any>(urls.BASE_URL + urls.GET_ASSIGNED_TRIPS_LIST, requestData)
      .pipe(
        catchError(errorHandl)
      );
  }

  getMemberTrips(requestData): Observable<any> {
    const queryParams = new URLSearchParams(requestData).toString();
    return this.http.post<any>(urls.BASE_URL + urls.GET_ASSIGNED_TRIPS_LIST ,requestData)
      .pipe(
        catchError(errorHandl)
      );
  }

  getCorporateUserList(): Observable<any> {

    return this.http.get<any>(urls.BASE_URL + urls.GET_CORPORATE_USER_LIST + '?accountStatus=' + 'active')
      .pipe(
        catchError(errorHandl)
      );
  }

  getCredentialedCorporateUserList(queryParams: any): Observable<any> {
    const params = new HttpParams({fromObject: queryParams});
    return this.http.get<any>(urls.BASE_URL + urls.GET_CREDENTIALED_CORPORATE_USER_LIST, { params })
      .pipe(
        catchError(errorHandl)
      );
  }


  getCorporateAddonsList(id?): Observable<any> {

    let subUrl;

    if (id) {
      subUrl = 'cooperate=' + id;
    } else {
      subUrl = 'isdefault=true';
    }


    return this.http.get<any>(urls.BASE_URL + 'addonservices/corporate?' + subUrl)
      .pipe(
        catchError(errorHandl)
      );
  }

  getTripsForAssignDashboard(): Observable<any> {

    return this.http.get<any>(urls.BASE_URL + urls.TRIPS_FOR_ASSIGN_DASHBOARD_URL)
      .pipe(
        catchError(errorHandl)
      );
  }

  assignTrip(data): Observable<any> {

    return this.http.put<any>(urls.BASE_URL + urls.GET_UNASSIGN_TRIPS_URL + `/${data._id}`, data)
      .pipe(
        catchError(errorHandl)
      );
  }

  assignMultipleTrip(data): Observable<any> {
    return this.http.post<any>(urls.BASE_URL + urls.ASSIGN_MULTIPLE_TRIPS_URL, data)
      .pipe(
        catchError(errorHandl)
      );
  }

  addBillerNote(data): Observable<any> {

    return this.http.put<any>(urls.BASE_URL + urls.GET_UNASSIGN_TRIPS_URL + `/${data._id}`, data)
      .pipe(
        catchError(errorHandl)
      );
  }

  addAdditionalNote(data): Observable<any> {

    return this.http.put<any>(urls.BASE_URL + urls.GET_UNASSIGN_TRIPS_URL + `/${data._id}`, data)
      .pipe(
        catchError(errorHandl)
      );
  }

  updateTrip(payload): Observable<any> {
    const id = payload._id;
    return this.http.put<any>(urls.BASE_URL + urls.GET_UNASSIGN_TRIPS_URL + `/${id}`, payload)
      .pipe(
        catchError(errorHandl)
      );
  }
  archiveTrip(payload,params): Observable<any> {
    const id = payload._id;
    return this.http.put<any>(urls.BASE_URL + urls.GET_UNASSIGN_TRIPS_URL + `/${id}`, params)
      .pipe(
        catchError(errorHandl)
      );
  }


  verifiedCancelTrip(data, id) {
    return this.http.post<any>(urls.BASE_URL + urls.VERIFIED_CANCEL_TRIP_URL + `/${id}`, data)
      .pipe(
        catchError(errorHandl)
      );
  }

  createNewTripV2(payload, tripId?): Observable<any> {
    if (tripId) {
      return this.http.put<any>(urls.BASE_URL + urls.CREATE_NEW_TRIP_URL + '/' + tripId, payload)
        .pipe(
          catchError(errorHandl)
        );
    } else {
      return this.http.post<any>(urls.BASE_URL + urls.CREATE_NEW_TRIP_URL, payload)
        .pipe(
          catchError(errorHandl)
        );
    }
  }

  IsoStringConversion(tripData) {
    const dates = { scheduleTime: ['schedulePickupHour', 'schedulePickupMinutes'], appointmentTime: ['appointmentPickupHour', 'appointmentPickupMinutes'], returnScheduleTime: ['returnPickupHour', 'returnPickupMinutes'] };
    Object.keys(dates).forEach(key => {
      let date = tripData[key].split('T')[0];
      tripData[key] = date + 'T';
      dates[key].forEach(element => {
        tripData[key] = tripData[key] + tripData[element] + ':';
      })
      tripData[key] = tripData[key] + '00.000Z';
    })
    return tripData;
  }

  getUnassignedTripDetailById(unassignedTripId): Observable<any> {

    return this.http.get<any>(urls.BASE_URL + urls.CREATE_NEW_TRIP_URL + '/' + unassignedTripId)
      .pipe(
        catchError(errorHandl)
      );
  }

  getAdjustedTrips(queryParams): Observable<any> {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get<any>(urls.BASE_URL + urls.GET_UNASSIGN_TRIPS_URL, { params })
      .pipe(
        catchError(errorHandl)
      );
  }
  getAdjustedTripsList(queryParams): Observable<any> {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get<any>(urls.BASE_URL + urls.GET_ADJUSTED_TRIPS_URL, { params })
      .pipe(
        catchError(errorHandl)
      );
  }

  getCompletedTrips(payload): Observable<any> {
    return this.http.post<any>(urls.BASE_URL + urls.GET_UNASSIGN_TRIPS_URL + '/getmanifesttrips', payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  adjustCompletedTrips(payload): Observable<any> {
    return this.http.post<any>(urls.BASE_URL + urls.GET_UNASSIGN_TRIPS_URL + '/getmanifesttrips', payload)
      .pipe(
        catchError(errorHandl)
      );
  }




  generateSignature(payload, endPoint): Observable<any> {

    return this.http.put<any>(urls.BASE_URL + urls.GENRATE_TRIP_SIGNATURE_URL + `/${endPoint}`, payload)
      .pipe(
        catchError(errorHandl)
      );
  }





  bankedTrips(payload): Observable<any> {

    return this.http.post<any>(urls.BASE_REPORT_SERVER_URL + urls.BANKED_TRIP_URL, payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  getETA(tripId) {
    return this.http.get<any>(urls.BASE_URL + urls.SINGLE_TRIP + '/' + tripId)
      .pipe(
        catchError(errorHandl)
      );
  }

  getDirtRoadTrips(params) {
    return this.http.get(
      urls.BASE_URL + urls.GET_UNASSIGN_TRIPS_URL, params);
  }

  sendTripAssistanceSMS(id, payload): Observable<any> {
    return this.http.post<any>(urls.BASE_URL + urls.GET_TRIP_ASSISTANCE_LIST + '/asssign/' + id, payload)
      .pipe(
        catchError(errorHandl)
      );
  }
  sendTrackingSMS(payload): Observable<any> {
    return this.http.post<any>(urls.BASE_URL + urls.TRACKING_SMS_URL, payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  generateTripsReport(payload) {
    return this.http.post<any>(urls.BASE_REPORT_SERVER_URL + urls.GENERATE_TRIPS_REPORT, payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  generateTripsIntineraryReport(payload) {
    return this.http.put<any>(urls.BASE_REPORT_SERVER_URL + urls.GENERATE_TRIPS_REPORT, payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  sendConfirmationText(payload) {
    return this.http.post<any>(urls.BASE_URL + urls.SEND_CONFIRMATION_TEXT_URL, payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  sendConfirmationCall(payload) {
    return this.http.post<any>(urls.OUT_BOUNDS_BASE_URL +"make-call", payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  sendBulkConfirmationCall(payload) {
    return this.http.post<any>(urls.OUT_BOUNDS_BASE_URL +"make-call-bulk", payload)
      .pipe(
        catchError(errorHandl)
      );
  }



  autoTripAdjustment(payload) {
    return this.http.post<any>(urls.BASE_URL + urls.AUTO_TRIP_ADJUSTMENT_URL, payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  adjustTripOdometer(payload) {
    return this.http.post<any>(urls.BASE_URL + urls.TRIP_ODOMETER_ADJUST_URL, payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  adjustAllTripsOdometer(payload) {
    return this.http.put<any>(urls.BASE_URL + urls.TRIP_ODOMETER_ADJUST_URL, payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  donwloadSoutheastransManifest(driverId, payload) {
    return this.http.post<any>(urls.BASE_REPORT_SERVER_URL + urls.GET_UNASSIGN_TRIPS_URL + '/manifest/' + driverId, payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  donwloadLogisticareManifest(payload) {
    return this.http.post<any>(urls.BASE_REPORT_SERVER_URL + urls.GET_UNASSIGN_TRIPS_URL + '/logisticmanifest', payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  donwloadLcpManifest(payload) {
    return this.http.post<any>(urls.BASE_REPORT_SERVER_URL + urls.GET_UNASSIGN_TRIPS_URL + '/lcpmanifest', payload)
      .pipe(
        catchError(errorHandl)
      );
  }




  tripsLog(payload) {
    return this.http.post<any>(urls.BASE_REPORT_SERVER_URL + urls.GET_UNASSIGN_TRIPS_URL + `/tripslog`, payload)
      .pipe(
        catchError(errorHandl)
      );
  }


  bankedTrip(payload) {
    return this.http.post<any>(urls.BASE_REPORT_SERVER_URL + urls.GET_UNASSIGN_TRIPS_URL + `/banked`, payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  claimFile(payload) {
    return this.http.post<any>(urls.BASE_REPORT_SERVER_URL + urls.GET_UNASSIGN_TRIPS_URL + `/claimfile`, payload)
      .pipe(
        catchError(errorHandl)
      );
  }



  getTripAssistanceList(): Observable<any> {
    return this.http.get<any>(urls.BASE_URL + urls.GET_TRIP_ASSISTANCE_LIST)
      .pipe(
        catchError(errorHandl)
      );
  }

  processTripAssistance(id, payload) {
    return this.http.put<any>(urls.BASE_URL + urls.GET_TRIP_ASSISTANCE_LIST + `/${id}`, payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  cloneStandingOrderTrip(id, queryParams): Observable<any> {
    const params = new HttpParams({ fromObject: queryParams });

    return this.http.get<any>(urls.BASE_URL + urls.GET_UNASSIGN_TRIPS_URL + `/clonetrip/${id}`, { params })
      .pipe(
        catchError(errorHandl)
      );
  }


  getCMSReport(params): Observable<any> {
    return this.http.post<any>(urls.BASE_URL + urls.GET_CMS_1500_REPORT, params)
  }
  fetchManifestTrips(payload): Observable<any> {
    return this.http.put<any>(urls.BASE_URL + urls.GET_UNASSIGN_TRIPS_URL + '/getmanifesttrips', payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  tripDetail(id): Observable<any> {

    return this.http.get<any>(urls.BASE_URL + urls.GET_UNASSIGN_TRIPS_URL + `/${id}`, id)
      .pipe(
        catchError(errorHandl)
      );
  }

  calculateEstimateFare(payload): Observable<any> {

    return this.http.post<any>(urls.BASE_URL + urls.CALCULATE_ESTIMATE_FARE, payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  getRoutingDistance(lat1, lon1, lat2, lon2): Observable<any> {
    let params = new HttpParams();
    params = params.append('start', lon1 + ',' + lat1);
    params = params.append('end', lon2 + ',' + lat2);

    return this.http.get<any>("https://routing.nemtplatform.com/ors/v2/directions/driving-car", { params })
      .pipe(
        catchError(errorHandl)
      );
  }

  liveTrips(payload) {
    return this.http
      .post<any>(`${urls.BASE_URL}assigns/selectedtrips`, payload).pipe(
        catchError(errorHandl)
      );
  }

  liveTripsForMultipleDriver(payload) {
    return this.http
      .put<any>(`${urls.BASE_URL}assigns/lines`, payload).pipe(
        catchError(errorHandl)
      );
  }

  getTripActivityLog(assignId) {
    return this.http
      .get<any>(urls.BASE_URL + urls.TRIP_ACTIVITY_LOG + "?assignId=" + assignId).pipe(
        catchError(errorHandl)
      );
  }

  savePlannerTemplate(payload, id?) {
    if (id) {
      return this.http.put<any>(urls.BASE_URL + urls.PLANNER_MAPPER + '/' + id, payload)
        .pipe(
          catchError(errorHandl)
        );
    } else {
      return this.http.post<any>(urls.BASE_URL + urls.PLANNER_MAPPER, payload)
        .pipe(
          catchError(errorHandl)
        );
    }
  }
  saveDriverPlannerTemplate(payload, id?) {
    if (id) {
      return this.http.put<any>(urls.BASE_URL + urls.PLANNER_DRIVER_MAPPER + '/' + id, payload)
        .pipe(
          catchError(errorHandl)
        );
    } else {
      return this.http.post<any>(urls.BASE_URL + urls.PLANNER_DRIVER_MAPPER, payload)
        .pipe(
          catchError(errorHandl)
        );
    }
  }

  getPlannerTemplates() {
    return this.http.get<any>(urls.BASE_URL + urls.PLANNER_MAPPER)
      .pipe(
        catchError(errorHandl)
      );
  }

  getDriverPlannerTemplates() {
    return this.http.get<any>(urls.BASE_URL + urls.PLANNER_DRIVER_MAPPER)
      .pipe(
        catchError(errorHandl)
      );
  }

  getPlannerTemplateById(id) {
    return this.http.get<any>(urls.BASE_URL + urls.PLANNER_MAPPER + '/' + id)
      .pipe(
        catchError(errorHandl)
      );
  }

  getDriverPlannerTemplateById(id) {
    return this.http.get<any>(urls.BASE_URL + urls.PLANNER_DRIVER_MAPPER + '/' + id)
      .pipe(
        catchError(errorHandl)
      );
  }

  downloadConfirmationReport(payload) {

    return this.http.post<any>(urls.BASE_URL + urls.TRIP_ACTIVITY_LOG, payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  get837FromReport(payload){
    return this.http.post<any>(urls.BASE_URL + 'adjusttrips/form837', payload)
    .pipe(
      catchError(errorHandl)
    );
  }
  get837FromReportv2(payload){
    return this.http.put<any>(urls.BASE_URL + 'adjusttrips/form837', payload)
    .pipe(
      catchError(errorHandl)
    );
  }

  signatureUpdate(payload) {
    return this.http.post<any>(urls.BASE_URL + urls.GET_UNASSIGN_TRIPS_URL + `/autosignature`, payload)
      .pipe(
        catchError(errorHandl)
      );
  }


    getCMS1500Report(payload){
      return this.http.post<any>(urls.BASE_URL + 'adjusttrips/cms1500', payload)
      .pipe(
        catchError(errorHandl)
      );
    }

  getInvoiceCSV(payload){
      return this.http.post<any>(urls.BASE_URL + 'adjusttrips/quickbook', payload)
      .pipe(
        catchError(errorHandl)
      );
    }
  // getMileageInvoiceCSV(payload){
  //     return this.http.put<any>(urls.BASE_URL + 'adjusttrips/quickbook', payload)
  //     .pipe(
  //       catchError(errorHandl)
  //     );
  //   }


  getMileageInvoiceCSV(payload) {
    return this.http.put<any>(urls.BASE_URL + 'adjusttrips/memberlogsheet', payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  getInvoiceCSV2(payload){
    return this.http.post<any>(urls.BASE_URL + 'adjusttrips/memberlogsheet', payload)
    .pipe(
      catchError(errorHandl)
    );
  }

  donwloadAllDriverLog(payload) {
    return this.http.post<any>(urls.BASE_REPORT_SERVER_URL + urls.GET_UNASSIGN_TRIPS_URL + '/mtm/alldriverlogs', payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  access2CareDriverLog(driverId, payload) {
    return this.http.put<any>(urls.BASE_REPORT_SERVER_URL + urls.GET_UNASSIGN_TRIPS_URL + `/access2care/${driverId}`, payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  donwloadDriverLog(payload) {
    return this.http.post<any>(urls.BASE_REPORT_SERVER_URL + urls.GET_UNASSIGN_TRIPS_URL + `/mtm/alldriverlogs`, payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  async setupTripsByPickup(params) {
    const {
      todayDate,
      user,
      selectedDriverId,
      drivers,
      violations,
      preSpaceTypes,
      selectedTimeLines,
      driverTrips,
      selectedTripsDriver,
      isGoogleMiles
    } = params;

    if (!selectedDriverId) return;

    const timeZone = user.timeZone;
    // const todayDate = moment.tz(timeZone).startOf('day').toISOString();

    const tripsPickupPoints = [];
    // this.waypoints = [];
    let driverShift;
    const currentDay = moment.tz(todayDate, timeZone).day();
    let selectedDriver = drivers.find(d => d._id === selectedDriverId);

    if (selectedDriver.shifts) {
      driverShift = selectedDriver.shifts.find(item => item.day === currentDay && item.isEnabled);
    }

    // checking driver and shift time
    if (selectedDriver) {
      selectedDriver.isPickup = true;
      selectedDriver.isDropOff = true;
      selectedDriver.jobOriginAddress = selectedDriver.startingPointAddress.address;
      selectedDriver.jobOriginLatitude = selectedDriver.startingPointAddress.latitude;
      selectedDriver.jobOriginLongitude = selectedDriver.startingPointAddress.longitude;

      selectedDriver.jobDestinationAddress = selectedDriver.startingPointAddress.address;
      selectedDriver.jobDestinationLatitude = selectedDriver.startingPointAddress.latitude;
      selectedDriver.jobDestinationLongitude = selectedDriver.startingPointAddress.longitude;

      if (driverShift) {

        tripsPickupPoints.push({
          ...selectedDriver,
          appointmentTime: moment(todayDate).tz(timeZone).set({ minute: driverShift.checkin.split(':')[1], hour: driverShift.checkin.split(':')[0], second: 0 }).toISOString(),
          scheduleTime: moment(todayDate).tz(timeZone).set({ minute: driverShift.checkin.split(':')[1], hour: driverShift.checkin.split(':')[0], second: 0 }).toISOString(),
          eta: moment(todayDate).tz(timeZone).set({ minute: driverShift.checkin.split(':')[1], hour: driverShift.checkin.split(':')[0], second: 0 }).toISOString(),
          distance: 0,
          travel: moment(todayDate).tz(timeZone).startOf('day').toISOString()
        });
        if (selectedTimeLines && selectedTimeLines.checkin) {
          const previousTrip = tripsPickupPoints[tripsPickupPoints.length - 1];
          previousTrip.eta = moment(selectedTimeLines.checkin).tz(timeZone).toISOString();
          previousTrip.arrive = moment(selectedTimeLines.checkin).tz(timeZone).toISOString();
          previousTrip.perform = moment(selectedTimeLines.checkin).tz(timeZone).toISOString();
        }

      } else {
        // removed eta from
        tripsPickupPoints.push({
          ...selectedDriver,
          appointmentTime: moment(todayDate).tz(timeZone).startOf('day').toISOString(),
          scheduleTime: moment(todayDate).tz(timeZone).startOf('day').toISOString(),
          eta: moment(todayDate).tz(timeZone).startOf('day').toISOString(),
          distance: 0,
          travel: moment(todayDate).tz(timeZone).startOf('day').toISOString()
        });
      }

      // chnage eta on base of current time
      let firstDriverTrip = tripsPickupPoints[tripsPickupPoints.length - 1];

      const now = moment().tz(timeZone);
      const eta = moment(firstDriverTrip.eta).tz(timeZone);
      const isSameDay = now.isSame(eta, 'day');
      if (isSameDay) {
        if (now.isAfter(eta)) {
          firstDriverTrip.eta = moment().tz(timeZone).toISOString();
        }
      }
    }
    // checking driver trip address point
    if (driverTrips && driverTrips.length) {
      for (let point of driverTrips) {

        //break here
        if (point.isBreakTrip) {
          // // // debugger;
          let previousStartBreakTrip = tripsPickupPoints[tripsPickupPoints.length - 1];
          let breakStartEta = moment(previousStartBreakTrip.eta).tz(timeZone).toISOString();
          const realEta =breakStartEta;
          const isStartEarly = moment(point.scheduleTime).tz(timeZone).isAfter(moment(breakStartEta).tz(timeZone));
          if (isStartEarly) {
            let durationOfTripTime = moment.duration(moment(breakStartEta).tz(timeZone).diff(moment(point.scheduleTime).tz(timeZone)));
            if (violations && violations.single && violations.single.pickupEarly !== 0 && Math.abs(durationOfTripTime.asMinutes()) > violations.single.pickupEarly) {
              breakStartEta = moment(point.scheduleTime).tz(timeZone).subtract(violations.single.pickupEarly, 'minutes').toISOString();
            }
          }

          // start
          tripsPickupPoints.push({ ...point, eta: breakStartEta, realEta:realEta, distance: 0, travel: previousStartBreakTrip.travel, isPickup: true, isDropOff: false });
          // debugger;
          // end Break
          let previousEndBreakTrip = tripsPickupPoints[tripsPickupPoints.length - 1];
          let breakEndEta = moment(previousEndBreakTrip.eta).tz(timeZone).toISOString();
          let realEndETA= breakEndEta;

          const isEarlyEndTwo = moment(point.appointmentTime).tz(timeZone).isAfter(moment(breakEndEta).tz(timeZone));
          if (isEarlyEndTwo) {
            let durationOfTripTimeTwo = moment.duration(moment(breakEndEta).tz(timeZone).diff(moment(point.appointmentTime).tz(timeZone)));
            if (violations && violations.single && violations.single.pickupEarly !== 0 && Math.abs(durationOfTripTimeTwo.asMinutes()) > violations.single.pickupEarly) {
              breakEndEta = moment(point.appointmentTime).tz(timeZone).subtract(violations.single.pickupEarly, 'minutes').toISOString();
            }
          }

          // end
          tripsPickupPoints.push({ ...point, eta: breakEndEta, realEta:realEndETA, distance: 0, travel: previousEndBreakTrip.travel, isPickup: false, isDropOff: true });

        } else {
          // first Trip
          let firstETA = moment(point.scheduleTime).tz(timeZone).toISOString();
          let firstDistance;
          let firstTravel = moment().tz(timeZone).set({ minute: 0, hour: 0, second: 0 }).toISOString();

          if (tripsPickupPoints && tripsPickupPoints.length) {

            let previousTrip = JSON.parse(JSON.stringify(tripsPickupPoints[tripsPickupPoints.length - 1]));
            //check break
            if (previousTrip.isBreakTrip) {
              previousTrip = JSON.parse(JSON.stringify(tripsPickupPoints[tripsPickupPoints.length - 3]));
              // update eta but not conceder Break lt lng
              previousTrip.eta = tripsPickupPoints[tripsPickupPoints.length - 1].eta

              // Show effect if break is in progress
              let breakTrip = JSON.parse(JSON.stringify(tripsPickupPoints[tripsPickupPoints.length - 1]));
              if (breakTrip.status && selectedTripsDriver && selectedTripsDriver.latitude !== null && selectedTripsDriver.longitude !== null && ['inprogress'].includes(breakTrip.status)) {
                const breakDriverDist = await this.getDistance(selectedTripsDriver.latitude, selectedTripsDriver.longitude, point.jobOriginLatitude, point.jobOriginLongitude, isGoogleMiles);
                previousTrip.eta = moment(previousTrip.eta).tz(timeZone).add(breakDriverDist.duration.toFixed(0), 'minutes').toISOString();
              }

            }

            if (previousTrip.priorityClient) {

              let distanceRes;
              if (previousTrip.job && previousTrip.job.trackInfoJob) {
                distanceRes = await this.getJobFirstPointDistance(previousTrip, [point.jobOriginLongitude, point.jobOriginLatitude], isGoogleMiles);
              } else {
                distanceRes = await this.getDistance(previousTrip.jobDestinationLatitude, previousTrip.jobDestinationLongitude, point.jobOriginLatitude, point.jobOriginLongitude, isGoogleMiles);


              }

              firstDistance = distanceRes;

              firstETA = moment(previousTrip.eta).tz(timeZone).add(distanceRes.duration.toFixed(0), 'minutes').toISOString();

              if (point.job && point.job.trackInfoJob && point.job.trackInfoJob.jobArrived && point.job.trackInfoJob.jobArrived.coords.length) {
                firstETA = moment(point.job.trackInfoJob.jobArrived.time).tz(timeZone).toISOString();
                let actualDistance = { distance: point.job.trackInfoJob.jobArrived.distance, duration: point.job.trackInfoJob.jobArrived.duration };

                if (point.job.trackInfoJob.jobStarted && point.job.trackInfoJob.jobStarted.coords.length) {
                  actualDistance.distance += point.job.trackInfoJob.jobStarted.distance;
                  actualDistance.duration += point.job.trackInfoJob.jobStarted.duration;
                }

                distanceRes = actualDistance;
                firstDistance = actualDistance;
              } else {
                //  add loadtime in ETA
                // previous trip not finished then add unload time here

                if (previousTrip.jobStatus && !['cancelled', 'finished'].includes(previousTrip.jobStatus) && preSpaceTypes[previousTrip.spaceType]) {
                  if (preSpaceTypes[previousTrip.spaceType].unloadTime) {
                    const unLaodTime = preSpaceTypes[previousTrip.spaceType].unloadTime.split(':');
                    firstETA = moment(firstETA).tz(timeZone).add(unLaodTime[1], 'minutes').add(unLaodTime[0], 'hours').toISOString();
                  }
                }
              }

              if (previousTrip.jobStatus && selectedTripsDriver && selectedTripsDriver.latitude !== null && selectedTripsDriver.longitude !== null && ['cancelled', 'finished'].includes(previousTrip.jobStatus)) {
                if (['offered', 'accepted', 'onway'].includes(point.jobStatus)) {
                  const driverDistanceRes = await this.getDistance(selectedTripsDriver.latitude, selectedTripsDriver.longitude, point.jobOriginLatitude, point.jobOriginLongitude, isGoogleMiles);
                  firstETA = moment.tz(timeZone).add(driverDistanceRes.duration.toFixed(0), 'minutes').toISOString();
                }
              }

              firstTravel = moment(previousTrip.travel).tz(timeZone).add(distanceRes.duration.toFixed(0), 'minutes').toISOString();

            } else {
              // debugger;

              let previousTripFirsTime = tripsPickupPoints[tripsPickupPoints.length - 1];
              //check break
              if (previousTripFirsTime.isBreakTrip) {
                previousTripFirsTime = tripsPickupPoints[tripsPickupPoints.length - 3];
              }

              // checking if previous point is driver
              if (!previousTripFirsTime.eta) {
                previousTripFirsTime.eta = point.scheduleTime;
                previousTripFirsTime.appointmentTime = point.scheduleTime;
                previousTripFirsTime.scheduleTime = point.scheduleTime;
              }

              let distanceRes = await this.getDistance(previousTripFirsTime.startingPointAddress.latitude, previousTripFirsTime.startingPointAddress.longitude, point.jobOriginLatitude, point.jobOriginLongitude, isGoogleMiles);

              firstDistance = distanceRes;
              firstETA = moment(previousTripFirsTime.eta).tz(timeZone).add(distanceRes.duration.toFixed(0), 'minutes').toISOString();


              if (point.job && point.job.trackInfoJob) {

                // set driver acctual start time
                if (point.job.trackInfoJob.jobAccepted && point.job.trackInfoJob.jobAccepted.coords.length) {
                  let driverDistanceRes = await this.getDistance(previousTripFirsTime.startingPointAddress.latitude, previousTripFirsTime.startingPointAddress.longitude, point.job.trackInfoJob.jobAccepted.coords[1], point.job.trackInfoJob.jobAccepted.coords[0], isGoogleMiles);
                  previousTripFirsTime.eta = moment(point.job.trackInfoJob.jobAccepted.time).tz(timeZone).subtract(driverDistanceRes.duration.toFixed(0), 'minutes').toISOString();
                  previousTripFirsTime.distance = driverDistanceRes.distance
                  previousTripFirsTime.travel = moment(previousTripFirsTime.travel).tz(timeZone).add(driverDistanceRes.duration.toFixed(0), 'minutes').toISOString();
                  // modifie for again for next calcu
                  firstETA = moment(previousTripFirsTime.eta).tz(timeZone).add(driverDistanceRes.duration.toFixed(0), 'minutes').toISOString();
                }

                if (point.job.trackInfoJob.jobArrived && point.job.trackInfoJob.jobArrived.coords.length) {
                  firstETA = moment(point.job.trackInfoJob.jobArrived.time).tz(timeZone).toISOString();
                  let actualDistance = { distance: point.job.trackInfoJob.jobArrived.distance, duration: point.job.trackInfoJob.jobArrived.duration };

                  if (point.job.trackInfoJob.jobStarted && point.job.trackInfoJob.jobStarted.coords.length) {
                    actualDistance.distance += point.job.trackInfoJob.jobStarted.distance
                    actualDistance.duration += point.job.trackInfoJob.jobStarted.duration
                  }

                  distanceRes = actualDistance;
                  firstDistance = actualDistance;

                  // update driver ETa,distance, travel time and distance in case of started first trip in very first entry update checkin and out time
                }
              }
              firstTravel = moment(previousTripFirsTime.travel).tz(timeZone).add(distanceRes.duration.toFixed(0), 'minutes').toISOString();
            }

          }
          const firstRealETA = firstETA;
          // if trip is not arrived
          if (['pending','offered', 'accepted', 'onway'].includes(point.jobStatus)) {
            // change eta base on volications sets
            const isEarly = moment(point.scheduleTime).tz(timeZone).isAfter(moment(firstETA).tz(timeZone));
            if (isEarly) {
              let durationOfTripTime = moment.duration(moment(firstETA).tz(timeZone).diff(moment(point.scheduleTime).tz(timeZone)));
              if (violations && violations.single && violations.single.pickupEarly !== 0 && Math.abs(durationOfTripTime.asMinutes()) > violations.single.pickupEarly) {
                firstETA = moment(point.scheduleTime).tz(timeZone).subtract(violations.single.pickupEarly, 'minutes').toISOString();
              }
            }
          }

          tripsPickupPoints.push({ ...point, eta: firstETA, realEta:firstRealETA, distance: firstDistance.distance, travel: firstTravel, isPickup: true, isDropOff: false });


          // second point
          const secondPreviousTrip = tripsPickupPoints[tripsPickupPoints.length - 1];
          let ckSecondDistance;
          if (secondPreviousTrip.job && secondPreviousTrip.job.trackInfoJob) {
            ckSecondDistance = await this.getJobSecondPointDistance([point.jobDestinationLongitude, point.jobDestinationLatitude], secondPreviousTrip, isGoogleMiles);
          } else {
            ckSecondDistance = await this.getDistance(secondPreviousTrip.jobOriginLatitude, secondPreviousTrip.jobOriginLongitude, point.jobDestinationLatitude, point.jobDestinationLongitude, isGoogleMiles);
          }
          let secondDistance = ckSecondDistance;
          let secondETA = moment(secondPreviousTrip.eta).tz(timeZone).add(ckSecondDistance.duration.toFixed(0), 'minutes').toISOString();


          if (point.job && point.job.trackInfoJob && point.job.trackInfoJob.jobCompleted && point.job.trackInfoJob.jobCompleted.coords.length) {
            secondETA = moment(point.job.trackInfoJob.jobCompleted.time).tz(timeZone).toISOString();

            let actualDistance = { distance: point.job.trackInfoJob.jobCompleted.distance, duration: point.job.trackInfoJob.jobCompleted.duration };
            if (point.job.trackInfoJob.jobFinished && point.job.trackInfoJob.jobFinished.coords.length) {
              actualDistance.distance += point.job.trackInfoJob.jobFinished.distance
              actualDistance.duration += point.job.trackInfoJob.jobFinished.duration
            }

            ckSecondDistance = actualDistance;
            secondDistance = actualDistance;
          }


          if (point.job && point.job.trackInfoJob && point.job.trackInfoJob.jobCancelled && point.job.trackInfoJob.jobCancelled.coords.length) {
            secondETA = moment(point.job.trackInfoJob.jobCancelled.time).tz(timeZone).toISOString();

            let actualDistance = { distance: 0, duration: 0 };

            ckSecondDistance = actualDistance;
            secondDistance = actualDistance;

          } else {
            //  add loadtime in ETA

            if (point.jobStatus && ['pending','offered', 'accepted', 'onway', 'arrived', 'started'].includes(point.jobStatus) && preSpaceTypes[point.spaceType]) {
              if (preSpaceTypes[point.spaceType].loadTime) {
                const LaodTime = preSpaceTypes[point.spaceType].loadTime.split(':');
                secondETA = moment(secondETA).tz(timeZone).add(LaodTime[1], 'minutes').add(LaodTime[0], 'hours').toISOString();
              }
            }


            if (point.jobStatus && selectedTripsDriver && selectedTripsDriver.latitude !== null && selectedTripsDriver.longitude !== null) {
              if (['started'].includes(point.jobStatus)) {
                const driverDistanceRes = await this.getDistance(selectedTripsDriver.latitude, selectedTripsDriver.longitude, point.jobDestinationLatitude, point.jobDestinationLongitude, isGoogleMiles);
                secondETA = moment.tz(timeZone).add(driverDistanceRes.duration.toFixed(0), 'minutes').toISOString();
              }
            }

          }

          const secondRealETA = secondETA;
          let secondTravel = moment(secondPreviousTrip.travel).tz(timeZone).add(ckSecondDistance.duration.toFixed(0), 'minutes').toISOString();

          if (['pending','offered', 'accepted', 'onway', 'arrived', 'started'].includes(point.jobStatus)) {
            // change eta base on volications sets
            const isEarlyTwo = moment(point.appointmentTime).tz(timeZone).isAfter(moment(secondETA).tz(timeZone));
            if (isEarlyTwo) {
              let durationOfTripTimeTwo = moment.duration(moment(secondETA).tz(timeZone).diff(moment(point.appointmentTime).tz(timeZone)));
              if (violations && violations.single && violations.single.pickupEarly !== 0 && Math.abs(durationOfTripTimeTwo.asMinutes()) > violations.single.pickupEarly) {
                secondETA = moment(point.appointmentTime).tz(timeZone).subtract(violations.single.pickupEarly, 'minutes').toISOString();
              }
            }
          }


          tripsPickupPoints.push({ ...point, eta: secondETA,realEta:secondRealETA, distance: secondDistance.distance, travel: secondTravel, isPickup: false, isDropOff: true });
        }
      }
    }
    // shift end
    if (selectedDriver) {
      selectedDriver.isPickup = true;
      selectedDriver.isDropOff = true;
      let lastTrip = JSON.parse(JSON.stringify(tripsPickupPoints[tripsPickupPoints.length - 1]));

      if (lastTrip.isBreakTrip) {
        lastTrip = JSON.parse(JSON.stringify(tripsPickupPoints[tripsPickupPoints.length - 3]));
        // update eta but not conceder Break lt lng
        lastTrip.eta = tripsPickupPoints[tripsPickupPoints.length - 1].eta;
      }

      let distanceRes;

      if (lastTrip.job && lastTrip.job.trackInfoJob) {
        distanceRes = await this.getJobFirstPointDistance(lastTrip, [selectedDriver.startingPointAddress.longitude, selectedDriver.startingPointAddress.latitude], isGoogleMiles);
      } else {
        distanceRes = await this.getDistance(lastTrip.jobDestinationLatitude, lastTrip.jobDestinationLongitude, selectedDriver.startingPointAddress.latitude, selectedDriver.startingPointAddress.longitude, isGoogleMiles);
      }
      if (driverShift) {
        const eta = moment(lastTrip.eta).tz(timeZone).add(distanceRes.duration.toFixed(0), 'minutes').toISOString();
        tripsPickupPoints.push({
          ...selectedDriver,
          appointmentTime: moment.tz(todayDate, timeZone).set({ minute: driverShift.checkout.split(':')[1], hour: driverShift.checkout.split(':')[0], second: 0 }),
          scheduleTime: moment.tz(todayDate, timeZone).set({ minute: driverShift.checkout.split(':')[1], hour: driverShift.checkout.split(':')[0], second: 0 }),
          eta: eta,
          distance: distanceRes.distance,
          travel: moment(lastTrip.travel).tz(timeZone).add(distanceRes.duration.toFixed(0), 'minutes').toISOString()
        });
        // set Check out time in shift case
        if (selectedTimeLines && selectedTimeLines.checkout) {
          const previousTrip = tripsPickupPoints[tripsPickupPoints.length - 1];
          previousTrip.arrive = moment(selectedTimeLines.checkout).tz(timeZone).toISOString();
          previousTrip.perform = moment(selectedTimeLines.checkout).tz(timeZone).toISOString();
        }

      } else {
        let eta = "0";
        let scheduleTime;
        let appointmentTime;

        if (lastTrip.appointmentTime)
          scheduleTime = moment(lastTrip.eta).tz(timeZone).add(distanceRes.duration.toFixed(0), 'minutes').toISOString();

        if (lastTrip.scheduleTime)
          appointmentTime = moment(lastTrip.eta).tz(timeZone).add(distanceRes.duration.toFixed(0), 'minutes').toISOString();

        if (lastTrip.eta)
          eta = moment(lastTrip.eta).tz(timeZone).add(distanceRes.duration.toFixed(0), 'minutes').toISOString();
        // removed eta from
        tripsPickupPoints.push({
          ...selectedDriver,
          appointmentTime,
          scheduleTime,
          distance: distanceRes.distance,
          eta,
          travel: moment(lastTrip.travel).tz(timeZone).add(distanceRes.duration.toFixed(0), 'minutes').toISOString()
        });
      }
    }

    return tripsPickupPoints;
  }

  async getDistance(lat1, lon1, lat2, lon2, isGoogleMiles) {
    let result: any;

    if (isGoogleMiles !== 'true') {
      result = await getDistanceFromLatLon(lat1, lon1, lat2, lon2);
    } else {
      const res: any = await this.getRoutingDistance(lat1, lon1, lat2, lon2).toPromise();
      const segments: any = res.features[0].properties.segments;
      result = {
        distance: (segments[0].distance / 1609),
        duration: (segments[0].duration / 60)
      }
    }

    return result;
  }

  async getJobFirstPointDistance(previousTrip, point, isGoogleMiles) {

    let coords = [previousTrip.jobDestinationLongitude, previousTrip.jobDestinationLatitude];

    if (previousTrip.job.trackInfoJob.jobFinished && previousTrip.job.trackInfoJob.jobFinished.coords.length) {
      coords = previousTrip.job.trackInfoJob.jobFinished.coords;
    } else if (previousTrip.job.trackInfoJob.jobCancelled && previousTrip.job.trackInfoJob.jobCancelled.coords.length) {
      coords = previousTrip.job.trackInfoJob.jobCancelled.coords;
    } else if (previousTrip.job.trackInfoJob.jobCompleted && previousTrip.job.trackInfoJob.jobCompleted.coords.length) {
      coords = previousTrip.job.trackInfoJob.jobCompleted.coords;
    } else if (previousTrip.job.trackInfoJob.jobStarted && previousTrip.job.trackInfoJob.jobStarted.coords.length) {
      coords = previousTrip.job.trackInfoJob.jobStarted.coords;
    } else if (previousTrip.job.trackInfoJob.jobArrived && previousTrip.job.trackInfoJob.jobArrived.coords.length) {
      coords = previousTrip.job.trackInfoJob.jobArrived.coords;
    } else if (previousTrip.job.trackInfoJob.jobAccepted && previousTrip.job.trackInfoJob.jobAccepted.coords.length) {
      coords = previousTrip.job.trackInfoJob.jobAccepted.coords;
    }

    const distance = await this.getDistance(coords[1], coords[0], point[1], point[0], isGoogleMiles);
    return distance;
  }

  async getJobSecondPointDistance(point, previousTrip, isGoogleMiles) {

    let coords = [previousTrip.jobOriginLongitude, previousTrip.jobOriginLatitude];

    // if (previousTrip.job.trackInfoJob.jobFinished && previousTrip.job.trackInfoJob.jobFinished.coords.length) {
    //   coords = previousTrip.job.trackInfoJob.jobFinished.coords;
    // } else  if (previousTrip.job.trackInfoJob.jobCancelled && previousTrip.job.trackInfoJob.jobCancelled.coords.length) {
    //   coords = previousTrip.job.trackInfoJob.jobCancelled.coords;
    // } else if (previousTrip.job.trackInfoJob.jobCompleted && previousTrip.job.trackInfoJob.jobCompleted.coords.length) {
    //   coords = previousTrip.job.trackInfoJob.jobCompleted.coords;
    // } else

    if (previousTrip.job.trackInfoJob.jobStarted && previousTrip.job.trackInfoJob.jobStarted.coords.length) {
      coords = previousTrip.job.trackInfoJob.jobStarted.coords;
    } else if (previousTrip.job.trackInfoJob.jobArrived && previousTrip.job.trackInfoJob.jobArrived.coords.length) {
      coords = previousTrip.job.trackInfoJob.jobArrived.coords;
    } else if (previousTrip.job.trackInfoJob.jobAccepted && previousTrip.job.trackInfoJob.jobAccepted.coords.length) {
      coords = previousTrip.job.trackInfoJob.jobAccepted.coords;
    }

    const distanceRes = await this.getDistance(coords[1], coords[0], point[1], point[0], isGoogleMiles);
    return distanceRes;
  }

  timeValidation(params) {
    const {
      trip,
      violations,
      timeZone
    } = params;
    let isEarly = '';

    // Pickup validation
    if (trip.isPickup && ['pending','offered', 'accepted', 'onway'].includes(trip.jobStatus)) {
      const isLate = moment(trip.eta).tz(timeZone).isAfter(moment(trip.scheduleTime).tz(timeZone));
      let duration = moment.duration(moment(trip.eta).diff(moment(trip.scheduleTime)));

      // Check if violations are available
      if (violations && violations.single) {
        const pickupLateThreshold = violations.single.pickupLate;
        const pickupEarlyThreshold = violations.single.pickupEarly;

        if (pickupLateThreshold !== 0 && isLate && duration.asMinutes() > pickupLateThreshold) {
          isEarly = 'late';
        } else if (pickupEarlyThreshold !== 0 && !isLate && Math.abs(duration.asMinutes()) > pickupEarlyThreshold) {
          isEarly = 'early';
        } else {
          isEarly = 'on time'; // Assuming on time if not late and duration is zero
        }
      } else {
        if (isLate) {
          isEarly = 'late';
        } else if (duration.asMinutes() > 0) {
          isEarly = 'early';
        } else {
          isEarly = 'on time'; // Assuming on time if not late and duration is zero
        }
      }

      // Drop-off validation
    } else if (trip.isDropOff && ['pending','offered', 'accepted', 'onway', 'started'].includes(trip.jobStatus)) {
      const isLate = moment(trip.eta).tz(timeZone).isAfter(moment(trip.appointmentTime).tz(timeZone));
      let duration = moment.duration(moment(trip.eta).diff(moment(trip.appointmentTime)));

      // Check if violations are available
      if (violations && violations.single) {
        const dropoffLateThreshold = violations.single.dropoffLate;
        const dropoffEarlyThreshold = violations.single.dropoffEarly;

        if (dropoffLateThreshold !== 0 && isLate && duration.asMinutes() > dropoffLateThreshold) {
          isEarly = 'late';
        } else if (dropoffEarlyThreshold !== 0 && !isLate && Math.abs(duration.asMinutes()) > dropoffEarlyThreshold) {
          isEarly = 'early';
        } else {
          isEarly = 'on time'; // Assuming on time if not late and duration is zero
        }
      } else {

        if (isLate) {
          isEarly = 'late';
        } else if (duration.asMinutes() > 0) {
          isEarly = 'early';
        } else {
          isEarly = 'on time'; // Assuming on time if not late and duration is zero
        }
      }
    }

    return isEarly;
  }
  donwloadMtmClaim(payload) {
    return this.http.put<any>(urls.BASE_REPORT_SERVER_URL + urls.GET_UNASSIGN_TRIPS_URL + '/claimfile', payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  donwloadCallTheCarInvoice(payload) {
    return this.http.post<any>(urls.BASE_REPORT_SERVER_URL + urls.GET_UNASSIGN_TRIPS_URL + '/callthecar', payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  //Planner Template API
  addPlannerTemplate(payload, id?) {
    if (id) {
      return this.http.put<any>(urls.BASE_URL + urls.PLANNER_TEMPLATE + '/' + id, payload)
        .pipe(
          catchError(errorHandl)
        );
    } else {
      return this.http.post<any>(urls.BASE_URL + urls.PLANNER_TEMPLATE, payload)
        .pipe(
          catchError(errorHandl)
        );
    }
  }

  getTemplateById(id) {
    return this.http.get<any>(urls.BASE_URL + urls.PLANNER_TEMPLATE + '/' + id)
      .pipe(
        catchError(errorHandl)
      );
  }

  getTemplateMembersnew(payload) {
    return this.http.post<any>(urls.BASE_URL + 'clientsspecific', payload)
      .pipe(
        catchError(errorHandl)
      );
  }

    getTemplates(status) {
    return this.http.get<any>(urls.BASE_URL + urls.PLANNER_TEMPLATE  + '?accountStatus=' + status)
      .pipe(
        catchError(errorHandl)
      );
  }


  createCloneTrip(id, payload){
    return this.http.put<any>(urls.BASE_URL +  'assigns/clonetrip' + '/' + id, payload)
    .pipe(
      catchError(errorHandl)
    );
  }

  billedToModivcare(payload) {
    return this.http.put<any>(urls.BASE_REPORT_SERVER_URL + urls.BILLED_TO_MODIVCARE_URL, payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  rePushToCTC(payload) {
    return this.http.post<any>(urls.BASE_REPORT_SERVER_URL + urls.RESEND_TO_CTC, payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  donwloadCorporateInvoiceReport(corporateUserId, payload) {
    return this.http.put<any>(urls.BASE_REPORT_SERVER_URL + urls.CORPORATE_USER_REPORT_URL + `/${corporateUserId}`, payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  donwloadCorporateInvoice(corporateUserId, payload) {
    return this.http.post<any>(urls.BASE_REPORT_SERVER_URL + urls.CORPORATE_USER_REPORT_URL + `/${corporateUserId}`, payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  memberTripsLogHHT(payload) {
    return this.http.put<any>(urls.BASE_REPORT_SERVER_URL + urls.GET_UNASSIGN_TRIPS_URL + `/membertripslog`, payload)
      .pipe(
        catchError(errorHandl)
      );
  }
  memberTripsLogHMT(payload) {
    return this.http.post<any>(urls.BASE_REPORT_SERVER_URL + urls.GET_UNASSIGN_TRIPS_URL + `/tripslog`, payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  memberTripsLog(payload) {
    return this.http.post<any>(urls.BASE_REPORT_SERVER_URL + urls.GET_UNASSIGN_TRIPS_URL + `/membertripslog`, payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  generateRawReport(queryParams): Observable<any> {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get<any>(urls.BASE_URL + urls.GET_ADJUSTED_TRIPS_URL + '/compare', { params })
      .pipe(
        catchError(errorHandl)
      );
  }

  getTrailsById(tripId) {
    return this.http.get<any>(urls.BASE_URL + urls.GET_UNASSIGN_TRIPS_URL + urls.TRAIL + `/${tripId}`)
    .pipe(
      catchError(errorHandl)
    );
  }

  cameraTripslog(payload) {
    return this.http.put<any>(urls.BASE_REPORT_SERVER_URL + urls.GET_UNASSIGN_TRIPS_URL + `/tripslog`, payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  calculateMiles(queryParam: any) {
    const params = new HttpParams({ fromObject: queryParam });
    return this.http.get('https://routing.nemtplatform.com/ors/v2/directions/driving-car', { params })
      .pipe(catchError(errorHandl));
  }

  getRoutePlanning(payload) {
    console.log('payload', payload);
    return this.http.post<any>("https://jspritapi.nemtplanner.com/api/routing/optimize", payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  getAssignManifestDriverReport(payload): Observable<any> {
    return this.http.put<any>(urls.BASE_URL + `${urls.GET_UNASSIGN_TRIPS_URL}/getmanifesttrips`, payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  sendBulkTripConfirmation(payload) {
    return this.http.post<any>(urls.BASE_URL + urls.BULK_TRIP_CONFIRMATION, payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  getMemberAllTrips(queryParams){
      const params = new HttpParams({ fromObject: queryParams });
      return this.http.get<any>(urls.BASE_URL + urls.GET_UNASSIGN_TRIPS_URL, { params })
        .pipe(
          catchError(errorHandl)
        );
    }

}


